/**
 * 合约 ABI 与 ethers Interface 统一入口
 *
 * 使用规范参见 [docs/ABI模块文档.md](../../docs/ABI模块文档.md)。
 *
 * - `depositAbi` / `erc20Abi`：原始 ABI JSON，需要传给 ethers Contract / 第三方工具时使用
 * - `depositInterface` / `erc20Interface`：预构造的 ethers Interface 实例，用于
 *   `encodeFunctionData` / `decodeFunctionResult` 等调用，避免运行时重复 parse ABI
 */

import { Interface } from 'ethers';

import depositJson from './deposit.json';
import erc20Json from './erc20.json';

/**
 * 充值合约 ABI
 *
 * 对应 yaml `createDepositOrder` 响应 `contractAddress` 合约。
 * 关键方法：`deposit(string orderNo, address token, uint256 amount) payable`。
 */
export const depositAbi = depositJson;

/**
 * 标准 ERC20 精简 ABI
 *
 * 仅保留前端充值流程所需方法：`approve` / `allowance` / `balanceOf` /
 * `decimals` / `symbol` / `transfer`，以及 `Approval` / `Transfer` 事件。
 */
export const erc20Abi = erc20Json;

/** 充值合约 Interface，用于编码/解码 deposit 等方法调用 */
export const depositInterface = new Interface(depositAbi);

/** ERC20 Interface，用于编码/解码 approve / allowance 等调用 */
export const erc20Interface = new Interface(erc20Abi);
